import controller from './mobilePayWithAlipay.controller';
import template from './mobilePayWithAlipay.html';

const MobilePayWithAlipayDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default MobilePayWithAlipayDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/mobilePayWithAlipay/mobilePayWithAlipay.component.js
 **/